<template>
  <Modal ref="modal" :title="title">
    <div class="mb-3">
      <div class="row g-3">
        <div class="col-md-4">
          <input
            type="text"
            class="form-control"
            :placeholder="$t('incomeStatement.enterItemName')"
            v-model="newItemName"
          />
        </div>
        <div class="col-md-2">
          <input
            type="number"
            class="form-control"
            :placeholder="$t('incomeStatement.amount')"
            v-model="newItemAmount"
          />
        </div>
        <div class="col-md-3">
          <select class="form-control" v-model="newItemCurrency">
            <option v-for="currency in currencies" :key="currency.code" :value="currency.code">
              {{ currency.code }}
            </option>
          </select>
        </div>
        <div class="col-md-3">
          <button
            class="btn btn-outline-primary w-100"
            type="button"
            @click="addItem"
          >
            {{ $t('incomeStatement.add') }}
          </button>
        </div>
      </div>
    </div>

    <div class="table-responsive">
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>{{ $t('incomeStatement.itemName') }}</th>
            <th class="text-end">{{ $t('incomeStatement.amount') }}</th>
            <th>{{ $t('incomeStatement.currency') }}</th>
            <th class="text-center">{{ $t('incomeStatement.actions') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item, index) in items" :key="index">
            <td>{{ item.name }}</td>
            <td class="text-end">{{ formatCurrency(item.amount) }}</td>
            <td>{{ item.currency_code }}</td>
            <td class="text-center">
              <button
                class="btn btn-sm btn-outline-danger"
                @click="deleteItem(index)"
              >
                {{ $t('incomeStatement.delete') }}
              </button>
            </td>
          </tr>
          <tr v-if="items.length === 0">
            <td colspan="4" class="text-center text-muted">
              {{ $t('incomeStatement.noItems') }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    
    <div class="mt-3">
      <div class="row">
        <div class="col-md-6">
          <div class="card p-3">
            <div class="text-muted">{{ $t('incomeStatement.total') }}</div>
            <div class="value">{{ formatCurrency(totalAmount) }}</div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="mt-3">
      <button class="btn btn-success" @click="saveChanges">
        {{ $t('incomeStatement.save') }}
      </button>
    </div>
  </Modal>
</template>

<script>
import Modal from "./Modal.vue";
import http from "@/modules/http";
import { mapState } from "vuex";

export default {
  name: "IncomeItemsModal",
  components: { Modal },
  data() {
    return {
      items: [],
      newItemName: "",
      newItemAmount: 0,
      newItemCurrency: "HUF",
      row: null,
      category: null,
      currency: "HUF",
      title: "Income Items",
      originalItems: []
    };
  },
  computed: {
    ...mapState(["currencies"]),
    totalAmount() {
      return this.items.reduce((sum, item) => sum + (item.amount || 0), 0);
    }
  },
  methods: {
    show(row, category = null) {
      this.row = row;
      this.category = category;
      console.log("Row data received:", row); // Debug line
      this.title = `${row.label} (${category || "No ID"}) - ${this.$t(
        "incomeStatement.items"
      )}`;
      this.$refs.modal.showModal();

      // Load existing items for the category (in a real implementation)
      this.items = [];
      this.originalItems = [];
    },
    addItem() {
      if (this.newItemName.trim() !== "") {
        this.items.push({
          name: this.newItemName.trim(),
          amount: this.newItemAmount || 0,
          currency_code: this.newItemCurrency
        });
        this.newItemName = "";
        this.newItemAmount = 0;
      }
    },
    deleteItem(index) {
      this.items.splice(index, 1);
    },
    saveChanges() {
      // Create the items using the API endpoint
      const promises = this.items.map((item) => {
        const data = {
          name: item.name,
          amount: item.amount,
          currency_code: item.currency_code,
          type: this.row.type, // income or expense
          date: new Date().toISOString().split("T")[0],
          category_id: this.category,
        };

        return http.fetch("/income-statement/items", data, true, "POST");
      });

      Promise.all(promises)
        .then(() => {
          console.log("Items saved successfully");
          alert(this.$t("incomeStatement.itemsSaved"));
          this.$refs.modal.hideModal();
          // Reset form
          this.items = [];
          this.newItemName = "";
          this.newItemAmount = 0;
          this.newItemCurrency = this.currencies[0]?.code || "HUF";
          // Notify parent to refresh the income statement data
          this.$emit("items-added");
        })
        .catch((error) => {
          console.error("Failed to save items:", error);
          alert(
            this.$t("incomeStatement.saveFailed") +
              ": " +
              (error.message || "Unknown error")
          );
        });
    },
    formatCurrency(value, currency = this.currency) {
      if (value === null || value === undefined) return "";
      return new Intl.NumberFormat("hu-HU", {
        style: "currency",
        currency: currency,
        maximumFractionDigits: 0,
      }).format(value);
    },
  },
};
</script>

<style scoped>
.value {
  font-size: 1.4rem;
  font-weight: 700;
}
</style>
